<template>
  <div class="field">
    <label class="label">{{label}}</label>
    <div class="control">
      <div class="ColorFilter">
        <div class="ColorFilter-block">
          <ul class="ColorFilter-list">
            <li class="ColorFilter-listItem" v-for="(value, key) in checkboxes" :key="key">
              <b-checkbox v-model="selected" :native-value="key">
                {{key}} <b-tag>{{value}}</b-tag>
              </b-checkbox>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorFilter',
  props: {
    label: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      checkboxes: this.data,
      selected: []
    }
  },
  watch: {
    data (data) {
      this.checkboxes = data
    },
    selected (data) {
      this.$emit('input', data)
    }
  }
}
</script>

<style scoped lang="scss">
.ColorFilter {
  &-block {
    background:
    linear-gradient(white 30%, hsla(0,0%,100%, 0)),
    linear-gradient(hsla(0,0%,100%,0) 10px, white 70%) bottom,
    radial-gradient(at top, rgba(0,0,0,0.2), transparent 70%), 
    radial-gradient(at bottom, rgba(0,0,0,0.2), transparent 70%) bottom;
    background-repeat:no-repeat;
    background-size: 100% 20px, 100% 20px, 100% 10px, 100% 10px;
    background-attachment:local, local, scroll, scroll;
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    max-height: 120px;
    overflow: auto;
    padding: 12px 0 12px 12px;
    &:hover {
      border-color: #b5b5b5;
    }
    @include from($tablet) {
      max-height: 140px;
    }
  }
}
</style>
